<template>
  <MTooltip>
    <template v-slot:trigger="triggerSlotData">
      <slot name="trigger" v-bind="triggerSlotData">
        <MButton
          variant="transparent"
          class="text-neutral-darker"
          size="small"
          :shadow="false"
          v-bind="$attrs"
          :aria-label="title"
          v-on="$listeners"
        >
          <slot />
        </MButton>
      </slot>
    </template>
    {{ title }}
  </MTooltip>
</template>

<script>
export default {
  name: 'EditorButton',
  props: { title: { type: String, required: true } },
}
</script>
